'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        fontSize: variables.SIZES.TEXT_MEDIUM,
        height: "32px",
        '[class*="MuiListSubheader-root"] ~ &[role="option"]': {
            paddingLeft: "20px",
        },
        "& div i": {
            color: variables.COLORS.GREYSCALE_25,
        },
    },
};

var MuiMenuItem = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiMenuItem = MuiMenuItem;
exports.light = light;
